import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react'

/* @TODO: Initial attempt only
* - apikey could move to env
* - could make hoc out of this
* - marker is static from flyspaces.com
*/
const API_KEY = process.env.GEO_API_KEY_FE

const SpaceMap = ({ lat, lng, zoom, onMarkerMove, google, style, address }) => {
  const [coord, setCoord] = useState({ lat, lng, address })
  useEffect(() => {
    if (address) {
      setCoord({ lat, lng, address })
      onMarkerMove({ lat, lng, address })
    }
  }, [address])
  return (
    <Map
      google={google}
      style={style}
      zoom={zoom}
      fullscreenControl={false}
      streetViewControl={false}
      initialCenter={coord}
      center={coord}
    >
      <Marker
        title=""
        options={{
          icon: {
            url: 'https://flyspaces.com/marker.png',
            anchor: new google.maps.Point(32, 32),
            scaledSize: new google.maps.Size(64, 64),
          },
          scrollwheel: false,
          zoom: 16,
        }}
        onDragend={({ position }) => {
          setCoord(position)
          onMarkerMove(position)
        }}
        draggable={true}
        position={coord}
      />
    </Map>
  )
}

SpaceMap.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
  onMarkerMove: PropTypes.func.isRequired,
  google: PropTypes.object.isRequired,
  style: PropTypes.object,
  address: PropTypes.string
}

export default GoogleApiWrapper({
  apiKey: API_KEY,
  v: '3',
})(SpaceMap)
